import _tokens from './tokens.js'

import { UnitType } from '@exodus/currency'

const name = 'ontology'
const displayName = 'Ontology'
const ticker = 'ONT'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const feeAssetName = 'ontologygas'
const primaryColor = '#7BCCEF'
const gradientColors = ['#7BCCEF', '#3A92CD']
const gradientCoords = { x1: '0%', y1: '-8.726%', x2: '103.772%', y2: '100%' }
const chainBadgeColors = gradientColors

const units = {
  ONT: 0,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.ont.io/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.ont.io/transaction/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Ontology Network is a blockchain/distributed ledger network which combines distributed identity verification, data exchange, data collaboration and supports multiple programming languages for decentralized application development.',
  reddit: 'https://www.reddit.com/r/OntologyNetwork',
  twitter: 'https://twitter.com/OntologyNetwork',
  website: 'https://ont.io',
  telegram: 'https://t.me/OntologyNetwork',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  feeAssetName,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export const tokens = _tokens.map((token) => {
  return {
    ...token,
    // name,
    // displayName,
    // ticker,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    // units
    assetType: 'ONTOLOGY_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    currency: UnitType.create(token.units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    feeAssetName,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    toString: () => token.name,
  }
})

export default [asset, ...tokens]
